import { isFeature } from 'Cloud/Application/FeaturesEs6';

export const allowUploadAtOverquota: boolean = isFeature('overquota-upload-allow');
